import { defaultQuery, FormState } from "modules/PsyCatalog/common/searchQuery/schema"
import { toQueryString } from "modules/PsyCatalog/common/searchQuery"

export interface SlugMeta {
    slug: string | null
    value: string | number
    kind: "city" | "competences" | "methods"
    h1: string
}

export type MetaList = Map<string | null, SlugMeta>

type FieldBySlug = Record<"cities" | "methods" | "competences", MetaList>

export class UrlBuilder {
    constructor(
        private readonly basePathname: string,
        private readonly filter: string,
        private readonly data: FormState,
        private readonly fieldBySlug: FieldBySlug
    ) {}

    private getSlugMeta(): SlugMeta | undefined {
        const city = this.fieldBySlug.cities.get(this.filter)
        const method = this.fieldBySlug.methods.get(this.filter)
        const competence = this.fieldBySlug.competences.get(this.filter)
        return city || method || competence
    }

    private buildQueryString(): string {
        if (!this.filter) return toQueryString(this.data)
        const meta = this.getSlugMeta()
        if (!meta) return toQueryString(this.data)
        const selected = meta.value
        const value = this.data[meta.kind]
        if (selected === value || (value.length === 1 && value[0] === selected)) {
            return toQueryString({
                ...this.data,
                [meta.kind]: defaultQuery[meta.kind],
            })
        }
        return toQueryString(this.data)
    }

    public build(): string {
        const queryString = this.buildQueryString()
        const defaultUrl = queryString.length
            ? `${this.basePathname}?${queryString}`
            : this.basePathname
        if (!this.filter) return defaultUrl
        const meta = this.getSlugMeta()
        if (!meta) return defaultUrl
        const selected = meta.value
        const value = this.data[meta.kind]
        const url = queryString.length ? `/psychologists?${queryString}` : "/psychologists"
        if (Array.isArray(value) && value.length === 1) {
            if (value[0] !== selected) {
                return url
            }
        } else if (value !== selected) return url
        return defaultUrl
    }
}
